<template>
    <div class="margin_12">
     <header3 :title="title"/>
     <paddingheader />
     <br/>
     <div class="language-selector">
          <select id="language-select"  v-model="lang" @change="handleChange">
              <option value="ru" >Русский</option>
              <option value="tj" >Тоҷикӣ</option>
          </select>
      </div>
     <div v-html="text" > </div>
       <div v-if="loading" align="center">
           <div>
           <Spinner />
           </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import header3 from '../blocks/header3';
import paddingheader from '../blocks/paddingheader';
import Spinner from '../blocks/spinner';
export default{
components:{
    Spinner, header3, paddingheader

  },
data() {
    return {
        title:"Правила сайта - Avtobaza.tj",
        loading:false,
        text:"",
        lang:"ru",
        
    }
  },
methods:{
 getpravila(){
     this.loading=true;
         axios({
           method: 'post',
            url: 'https://avtobaza.tj/api/pravila',
            data: {
            lang: this.lang,
           }
          })
        .then(res=>{
            if(res.data.status){
              this.loading=false;
              this.text=res.data.text;
            }
        });
   },
   handleChange() {
       if(this.lang=="tj") this.title= 'Қоидаҳои сомонаи - Avtobaza.tj';
       else this.title= 'Правила сайта - Avtobaza.tj';
       this.text="";
       this.getpravila();
    }
},
mounted(){
    this.getpravila();
}
}
</script>
<style scoped>

/* Стили для выпадающего списка */
.language-selector {
  display: inline-block;
}

/* Стили для самого выпадающего списка */
#language-select {
  padding: 7px;
  margin-left: 5px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
  cursor: pointer;
  width: 100px;
}


</style>
